import { isCryptoCurrency } from "../constants/walletMethods.constants";

const LOCALE_TAGS: Record<string, string> = {
  es: "es-CO",
  en: "en-US",
  pt: "pt-BR",
};

/** App language → regional BCP 47 tag so Intl grouping matches the main markets (CO/US/BR). */
export const resolveLocale = (locale: string): string => LOCALE_TAGS[locale] ?? locale;

/**
 * Fiat currencies of the new payments-runtime corridors (Colombia, México, Brasil, Argentina). Their balances
 * render with the real decimals sent by the backend — never rounded to the integer — so the wallets view
 * matches the dispersions view for these corridors.
 */
const RUNTIME_DECIMAL_CURRENCIES: ReadonlySet<string> = new Set(["COP", "MXN", "BRL", "ARS"]);

/**
 * Fraction-digit range shown per currency across the module (cards, hero, rows, detail). Fed to
 * `ColocaAmountDisplay` as `minimumFractionDigits`/`maximumFractionDigits` so every amount renders
 * consistently, formatting the decimal string with Intl (no `Number` round-trip, no precision loss):
 *
 * - Crypto and USD: exactly 2.
 * - Runtime fiat corridors (COP, MXN, BRL, ARS): min 2, up to 8 — mirrors dispersions and the backend's decimal
 *   string, so the balance is never rounded to the integer.
 * - Any other fiat: 0 (unchanged).
 */
export const currencyFractionDigits = (currency: string): { min: number; max: number } => {
  const code = currency.toUpperCase();
  if (isCryptoCurrency(code) || code === "USD") return { min: 2, max: 2 };
  if (RUNTIME_DECIMAL_CURRENCIES.has(code)) return { min: 2, max: 8 };
  return { min: 0, max: 0 };
};
